import {
  AppDatePicker, AppInputNumber, AppRemixIcon,
} from '@/layout/AppComponents';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { createPortal } from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import Translator from '../../../../../../components/helpers/Translator';

const CalendarNextDateSettings = (props) => {
  const { plantObligationID, onChange } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const poNextDateSettings = useSelector((state) => state.currentPage?.plantObligationLevels?.level3?.[plantObligationID]?.calendar?.nextDateSettings);
  const oNextDateType = useSelector((state) => state.currentPage?.plantObligationLevels?.level2?.[plantObligationID]?.obligation?.nextDateType);
  const dispatch = useDispatch();
  // < EDIT NEXTDATE SETTINGS
  const handleEditNextDateSettings = async (values) => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_calendar_changeNextDateSettings"
        ),
        {
          ...values,
          ...{
            moduleBridgeHex,
            plantHex,
            plantObligationID,
          },
        }
      );
      dispatch(currentPageAction.change('calendarTabs', { [plantObligationID]: response.data }));
      onChange(null);
    } catch (err) {}
  };
  // > EDIT NEXTDATE SETTINGS

  return (
    <>
      <h3>
        <Translator file="module-legalCompliance" name="set.deadline" />
        <AppRemixIcon
          icon="close"
          className="float-right pointer mr-2"
          size={16}
          onClick={() => { onChange(null); }}
        />
      </h3>
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        initialValues={{
          date: poNextDateSettings?.date || '',
          period: poNextDateSettings?.period || '',
        }}
        onSubmit={handleEditNextDateSettings}
      >
        {({
          setFieldValue,
          handleSubmit,
          values,
        }) => (
          <>
            <AppDatePicker
              title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="date" />)}
              value={values.date}
              onChange={(opt) => setFieldValue('date', opt)}
              placeholder="dd-mm-yyyy"
              dateFormat="dd-mm-yyyy"
              displayDateFormat="DD-MM-YYYY"
              showMonthDropdown
              showYearDropdown
              popperClassName="react-datepicker-popper-100"
              popperContainer={({ children }) => createPortal(children, document.body)}
            />
            {oNextDateType === 1 && (
              <AppInputNumber
                title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="months" />)}
                placeholder={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="period.of.months" />)}
                value={values.period}
                onChange={(value) => setFieldValue('period', value)}
                icon={<AppRemixIcon icon="brackets" />}
                isClearable
              />
            )}
            <div className="float-right">
              <span className="btn btn-outline-light mr-2" onClick={() => onChange(null)}>
                <Translator file="user" name="user.cancel" />
              </span>
              <span className="btn btn-outline-info" onClick={handleSubmit}>
                <Translator file="general" name="general.update" />
              </span>
            </div>
          </>
        )}
      </Formik>
    </>
  );
};
export default CalendarNextDateSettings;
